import http from './http';

const BASE_URL_PACKAGE = '/subscription-package';

const getSubcriptionPackage = (callback) => {
  http
    .get(`${BASE_URL_PACKAGE}`)
    .then((res) => callback({ payload: res.data.payload, error: null }))
    .catch((error) => callback({ payload: null, error: error.response }));
};

// --- Subscription Page Sections ---
const BASE_URL_SECTION = '/section/subscription-page';
const getHeroSection = (callback) => {
  http
    .get(`${BASE_URL_SECTION}/hero`)
    .then((res) => callback({ payload: res.data, error: null }))
    .catch((error) => callback({ payload: null, error: error.response }));
};

const getFeatureSection = (callback) => {
  http
    .get(`${BASE_URL_SECTION}/benefit`)
    .then((res) => callback({ payload: res.data, error: null }))
    .catch((error) => callback({ payload: null, error: error.response }));
};

const getOfferSection = (callback) => {
  http
    .get(`${BASE_URL_SECTION}/offer`)
    .then((res) => callback({ payload: res.data, error: null }))
    .catch((error) => callback({ payload: null, error: error.response }));
};

// Gabungkan semua service terkait subscription
export const SERVICE_SUBSCRIPTION = {
  getSubcriptionPackage, getHeroSection, getFeatureSection, getOfferSection
};
